import { EventParam } from "@core/analytics/analytics-event";
import { isApiError } from "@core/api/api-error";
import { NetworkAnalyticsHandler } from "@core/api/error-handling-api-service";
import { AnalyticsCategory, AppAnalyticsService } from "@domain/analytics/analytics-types";

export class NetworkAnalyticsManager implements NetworkAnalyticsHandler {
	constructor(private readonly analyticsService: AppAnalyticsService) {}

	trackError(error: unknown, params?: EventParam[]): void {
		this.analyticsService.trackEvent({
			category: AnalyticsCategory.ERROR,
			action: isApiError(error) ? "serverError" : "networkError",
			params: isApiError(error) ? [error.status, ...(params ?? [])] : params,
		});
	}
}
